import AxiosService from '@core/services/app/axiosService';
import authHeader from '@core/services/app/authHeader';
import appConsoleService from '@core/services/utils/appConsoleService';

/**
 * Journal d'activité (/appActivity/*). Les consultations et les actions métier
 * sont déduites côté serveur des appels /api (en-tête X-App-Menu-Key, cf.
 * axiosService) ; `track` ne sert qu'aux actions sans appel serveur
 * (connexion, export généré dans le navigateur…). Singleton.
 */
class AppActivityService {

  /** Fire-and-forget : une erreur de journalisation ne gêne jamais l'utilisateur. */
  track(kind, entry = {}) {
    AxiosService.post('/appActivity/track', {kind, ...entry}, {headers: authHeader()})
      .catch(error => appConsoleService.error('appActivityService', error));
  }

  /** Export généré côté navigateur (SheetJS, CSV…) : nom de fichier complet, extension comprise. */
  trackExport(fileName) {
    const ext = String(fileName || '').split('.').pop().toLowerCase() || 'file';
    this.track('EXPORT', {targetLabel: fileName || null, action: `client.export.${ext}`});
  }

  /**
   * @param {Object} criteria filter, module, search, before, userId ('all' | id, administration)
   */
  async timeline(criteria = {}) {
    const res = await AxiosService.post('/appActivity/timeline',
      {...criteria, tzOffset: new Date().getTimezoneOffset()}, {headers: authHeader()});
    return res.data;
  }

  async recent(limit = 20) {
    const res = await AxiosService.post('/appActivity/recent', {limit}, {headers: authHeader()});
    return res.data?.items || [];
  }

  async hide(ids, scope = null) {
    const res = await AxiosService.post('/appActivity/hide', {ids, scope}, {headers: authHeader()});
    return res.data?.count || 0;
  }

  async hideViews(menuKey) {
    const res = await AxiosService.post('/appActivity/hideViews', {menuKey}, {headers: authHeader()});
    return res.data?.count || 0;
  }

  async users() {
    const res = await AxiosService.post('/appActivity/users', {}, {headers: authHeader()});
    return res.data?.users || [];
  }
}

export default new AppActivityService();
